import React from 'react';
import { Box, Text, Button, SimpleGrid } from '@chakra-ui/react';
import { toast } from 'sonner';
import { CheckCircle, XCircle, AlertTriangle, Info, Loader } from 'lucide-react';
const TEAL = '#00897B';
const toastActions = [{
  label: 'Success',
  icon: <CheckCircle size={18} data-id="element-407" />,
  bg: '#00897B',
  hoverBg: '#00695C',
  fire: () => toast.success('Operation Successful', {
    description: 'Your changes have been saved successfully.'
  })
}, {
  label: 'Error',
  icon: <XCircle size={18} data-id="element-408" />,
  bg: '#D32F2F',
  hoverBg: '#B71C1C',
  fire: () => toast.error('An Error Occurred', {
    description: 'Something went wrong. Please try again.'
  })
}, {
  label: 'Warning',
  icon: <AlertTriangle size={18} data-id="element-409" />,
  bg: '#F57C00',
  hoverBg: '#E65100',
  fire: () => toast.warning('Warning', {
    description: 'This action may have unintended consequences.'
  })
}, {
  label: 'Info',
  icon: <Info size={18} data-id="element-410" />,
  bg: '#1565C0',
  hoverBg: '#0D47A1',
  fire: () => toast.info('Did You Know?', {
    description: 'You can update board and committee members at any time.'
  })
}, {
  label: 'Loading',
  icon: <Loader size={18} data-id="element-411" />,
  bg: '#6A1B9A',
  hoverBg: '#4A148C',
  fire: () => toast.loading('Processing...', {
    description: 'Please wait while we process your request.',
    duration: 3000
  })
}];
export function ToastPage() {
  return <Box px={10} py={8} maxW="600px" data-id="element-412">
      <Text fontSize="2xl" fontWeight="bold" color="black" mb={2} data-id="element-413">
        Toast Notifications
      </Text>
      <Text fontSize="md" color="gray.600" mb={8} data-id="element-414">
        Click a button below to preview each notification type. Toasts appear in
        the upper-right corner.
      </Text>

      <SimpleGrid columns={[1, 2, 3]} spacing={4} data-id="element-415">
        {toastActions.map(({
        label,
        icon,
        bg,
        hoverBg,
        fire
      }) => <Button key={label} leftIcon={icon} bg={bg} color="white" size="md" borderRadius="md" fontWeight="semibold" px={6} _hover={{
        bg: hoverBg
      }} _active={{
        bg: hoverBg,
        transform: 'scale(0.97)'
      }} transition="all 0.15s" onClick={fire} data-id="element-416">
            {label}
          </Button>)}
      </SimpleGrid>
    </Box>;
}